import isObject from './isObject'

const deepEach = (obj, callback, path) => {
  const keys = path || []

  for (const key of Object.keys(obj)) {
    const value = obj[key]

    if (isObject(value)) {
      deepEach(value, callback, keys.concat(key))
    } else {
      callback(key, value, keys)
    }
  }
}

export default deepEach
